export const TEXTS = {
  CREATE_POINTS_GROUP: 'Создать группу',
  PAGE_TITLE: 'Адреса',
  DOC_TITLE: 'Группы адресов – Звук Бизнес',
  TEXT_POINTS_SEARCH_EMPTY: 'Мы не нашли групп адресов по такому запросу',
  TEXT_POINTS_GROUPS_EMPTY: 'Создайте свою первую группу адресов',
  EMPTY_STATE_DESCRIPTION:
    'В этом разделе вы можете объединять адреса и запускать на них синхронное воспроизведение видеоволн. Идеально для цифровых вывесок, трансляций в торговых залах или фонового видео в разных комнатах.',
  HELP_BUTTON: 'Хелп-центре',
  EMPTY_STATE_HELP_TEXT: 'Подробную инструкцию можно найти в ',
  POINTS_LIST_EMPTY: 'У вас нет адресов',
  SEARCH: 'Поиск по адресам',
  MODAL_SELECT_POINTS_BUTTON_SUBMIT_TEXT: 'Сохранить',
  NEXT: 'Далее',
  CANCEL: 'Отменить',
  SAVE: 'Сохранить',
  MODAL_SELECT_POINTS_TITLE: 'Выбор адресов',
  MODAL_SELECT_MASTER_VIDEO_STREAM_TITLE: 'Выбор мастер-видеоволны',
  MODAL_SELECT_MASTER_VIDEO_STREAM_DESCRIPTION:
    'Все видеоволны в группе будут подстроены по длительности под выбранную мастер-видеоволну',
  SELECT_POINTS_SUCCESS: 'Адреса успешно изменены',
  SELECT_MASTER_VIDEO_STREAM_SUCCESS: 'Мастер-видеоволна успешно изменена',
  CREATE_GROUP_SUCCESS: 'Группа адресов успешно создана',
  BACK: 'Назад',
  BINDED_TO_OTHER_GROUPS_ERROR:
    'Не удалось создать список адресов, адреса и видеоволны могут быть только в одной группе',
};
